/**
 * Quick-buy variant image prefetch
 * ---------------------------------------------------------------------------
 * In the quick-buy drawer/popover, theme.min.js swaps the product image on
 * variant change by setting src to getSizedMediaUrl(featured_media, "342x"),
 * which uses the "_342x" filename-infix CDN format. That is a different URL
 * (and therefore a different browser-cache entry) than the "?width=" URL the
 * Liquid markup renders for the initial image, so every swatch change triggers
 * a fresh network fetch and a visible delay.
 *
 * This script prefetches that exact "_342x" URL when the shopper hovers or
 * focuses a swatch, so by the time they click, the image paints from cache.
 * It only touches swatches inside <quick-buy-drawer>/<quick-buy-popover>, fetches
 * the product JSON lazily (once per handle, on first interaction), and respects
 * Save-Data / very slow connections.
 */
(function () {
  'use strict';

  // Honor data saver and 2g-class connections - don't speculatively fetch.
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData || /^(slow-)?2g$/.test(conn.effectiveType || ''))) return;

  var productCache = {}; // handle -> Promise<product JSON>
  var prefetched = {};   // url -> true (dedupe)

  function loadProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return productCache[handle];
  }

  // Mirror theme.js getSizedMediaUrl(media, "342x"): insert _342x before the
  // file extension (handles an optional ?v=NNN suffix).
  function sized342(src) {
    if (!src) return null;
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (!match) return null;
    var prefix = src.split(match[0])[0];
    return prefix + '_342x' + match[0];
  }

  function variantImageSrc(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
      return variant.featured_media.preview_image.src;
    }
    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }
    if (typeof variant.featured_image === 'string') {
      return variant.featured_image;
    }
    return null;
  }

  function prefetch(url) {
    if (!url || prefetched[url]) return;
    prefetched[url] = true;
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
  }

  function handleSwatchIntent(radio) {
    var variants = radio.closest('product-variants');
    if (!variants) return;
    var handle = variants.getAttribute('handle');
    if (!handle) return;

    // Swatch radios are named "option{position}" (1-based).
    var nameMatch = (radio.name || '').match(/option(\d+)/);
    if (!nameMatch) return;
    var optionIndex = parseInt(nameMatch[1], 10) - 1;
    var value = radio.value;
    if (optionIndex < 0 || value == null) return;

    loadProduct(handle).then(function (product) {
      if (!product || !product.variants) return;
      // Featured media is per-color, so the first variant matching this option
      // value carries the image the swap will show.
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var opts = v.options || [];
        if (String(opts[optionIndex]) === String(value)) {
          prefetch(sized342(variantImageSrc(v)));
          break;
        }
      }
    });
  }

  // Delegate so it works for swatches injected after load (quick-buy content).
  function onIntent(event) {
    var label = event.target.closest('.color-swatch__item, .variant-swatch__item, .color-swatch, .variant-swatch');
    if (!label) return;
    var inQuickBuy = label.closest('quick-buy-drawer, quick-buy-popover');
    if (!inQuickBuy) return;
    var radio = label.parentElement ? label.parentElement.querySelector('input[type="radio"]') : null;
    if (!radio && label.htmlFor) radio = document.getElementById(label.htmlFor);
    if (radio) handleSwatchIntent(radio);
  }

  // pointerover covers mouse + pen; focusin covers keyboard users.
  document.addEventListener('pointerover', onIntent, { passive: true });
  document.addEventListener('focusin', onIntent);
})();
